var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"justify-center align-center",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"primary--text title text-center"},[_c('p',{staticClass:"ma-10 pt-10"},[_vm._v(_vm._s(_vm.$t('logoutTitle')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }